import { Route, Routes } from "react-router-dom"
import { Confirmation } from "../pages/Confirmation/Confirmation"
import { ManageDataReceipt } from "../pages/DataReceipt/ManageDataReceipt"
import { DataReceiptsViewTable } from "../pages/DataReceipt/table-view/DataReceiptsViewTable"
import { FlightplanEditor } from "../pages/FlightplanEditor/FlightplanEditor"
import { FlightplanUpload } from "../pages/FlightplanUpload/FlightplanUpload"
import { Landing } from "../pages/Landing/Landing"
import { LookupEditor } from "../pages/LookupEditor/LookupEditor"
import { MissionEditorWrapper } from "../pages/MissionEditor/MissionEditorWrapper"
import { MissionReviewPage } from "../pages/MissionReview/MissionReviewPage"
import { MissionSelection } from "../pages/MissionSelection/MissionSelection"
import { MissionUpload } from "../pages/MissionUpload/MissionUpload"
import { ProjectEditor } from "../pages/ProjectEditor/ProjectEditor"
import { ProjectInit } from "../pages/ProjectInit/ProjectInit"
import { SensorInstallRecentTable } from "../pages/SensorInstallation/SensorInstallRecentTable"
import { SensorInstallsForSensorTable } from "../pages/SensorInstallation/SensorInstallsForSensorTable"
import { routes } from "./NexRoutes"

const projNumPlaceholder = ":projectNumber"
const flightPlanIdPlaceholder = ":flightPlanId"
const missionIdPlaceholder = ":missionId"

export const MainRoutingSwitch = () => {
    return (
        <Routes>
            <Route path={routes.home} element={<Landing />} />
            <Route path={`${routes.projectInit}/${projNumPlaceholder}`} element={<ProjectInit />} />
            <Route path={routes.projectInit} element={<ProjectInit />} />
            <Route path={routes.lookupEditor} element={<LookupEditor />} />
            <Route path={routes.createDataReceipt} element={<ManageDataReceipt />} />
            <Route path={routes.editDataReceipt()} element={<ManageDataReceipt />} />
            <Route path={routes.dataReceipts} element={<DataReceiptsViewTable />} />

            <Route path={routes.confirmation()} element={<Confirmation />} />

            {/* project number required */}
            <Route path={`/${projNumPlaceholder}${routes.projectEditor}`} element={<ProjectEditor />} />
            <Route path={`/${projNumPlaceholder}${routes.flightplanUpload}`} element={<FlightplanUpload />} />
            <Route
                path={`/${projNumPlaceholder}${routes.flightplanEditor}/:flightplanFlow/${flightPlanIdPlaceholder}?`}
                element={<FlightplanEditor />}
            />
            <Route path={`/${projNumPlaceholder}${routes.missionUpload}`} element={<MissionUpload />} />
            <Route path={`/${projNumPlaceholder}${routes.missionSelect}`} element={<MissionSelection />} />
            <Route
                path={`/${projNumPlaceholder}${routes.missionEditor}/:missionFlow/${missionIdPlaceholder}?`}
                element={<MissionEditorWrapper />}
            />
            <Route
                path={`/${projNumPlaceholder}${routes.missionReview}/${missionIdPlaceholder}?`}
                element={<MissionReviewPage />}
            />

            <Route path={routes.sensorInstallations} element={<SensorInstallRecentTable />} />
            <Route path={routes.sensorInstallationsForSensor()} element={<SensorInstallsForSensorTable />} />
        </Routes>
    )
}
